// Run tests: jest src/models/__tests__/Branch.model.spec.js
export class Branch {
  constructor(data) {
    this.id = data.id
    this.name = data.name
    this.level = data.level
    this.branchCode = data.branch_code
  }

  static sortByLevelAndOrder() {
    return (a, b) => a.level - b.level || a.order - b.order // sort by level first, then by order
  }

  getFormattedName(showBranchCode = false) {
    if (!showBranchCode) {
      return this.name
    }

    const indentation = '- '.repeat(this.level - 1)

    return `${indentation}${this.branchCode} ${this.name}`.trim()
  }
}
